<template>
  <div id="app">
    <router-view></router-view>
    <bottom-nav></bottom-nav>
    <loading v-show="loading"></loading>
  </div>
</template>

<script>
import Loading from "./components/loading.vue";
import BottomNav from "./components/bottom-nav";

import { mapState } from "vuex";
export default {
  name: "App",
  components: {
    Loading,
    BottomNav,
  },
  computed: {
    ...mapState(["loading"]),
  },
  mounted(){
    this.getPreheatConfig()
  },
  methods: {
    getPreheatConfig(){
      this.$http.get('/v1/wechat/preheat').then(res=>{
        var address = ["preheatbase","likedetailbase","seckillDetailbase", "ddeeminelive"];
        if (res&&res.data) {
          res.data.split(",").forEach((el, i) => {
            if (el.length) {
              address[i] = el
            }
          });
        }
        localStorage.setItem('preheatPath',`/${address[0]}`);
        localStorage.setItem('likedetailPath',`/${address[1]}`);
        localStorage.setItem('seckillDetailPath',`/${address[2]}`);
        localStorage.setItem('myPagePath',`/${address[3]}`);
      })
    }
  }
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
.html-content {
  line-height: 24px;
}
.html-content img {
  max-width: 100%;
}
</style>
